var _defs, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTirAuButHand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #54a9a4;\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n\n      .st2 {\n        fill: #47464b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.8,50.5l-.2-27.2c0-.1,0-.2.1-.3,0,0,.2-.1.3-.1h49.5c.2,0,.4.2.4.4l.2,27.2h-.9s-.2-26.8-.2-26.8h-48.7l.2,26.8h-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99.3,51.3l-4-5.4c0,0,0-.2,0-.3l4-22.3h.8c0,.1-3.9,22.3-3.9,22.3l3.9,5.2-.7.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 54.3,
    y: 45.2,
    width: 41.4,
    height: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.3,45.7l-3.3-22.3c0-.1,0-.2,0-.3,0,0,.2-.1.3-.1h4.1c.2,0,.4.2.4.4l2.5,22.3h-.9c0,0-2.4-21.8-2.4-21.8h-3.2l3.2,21.8h-.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 55.9,
    y: 23.1,
    width: 0.9,
    height: 22.7,
    transform: "translate(-5.3 10.7) rotate(-10.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M88.6,45.7h-.8c0-.1,3.2-21.9,3.2-21.9h-3.2l-2.4,21.9h-.9c0,0,2.5-22.4,2.5-22.4,0-.2.2-.4.4-.4h4.1c.1,0,.2,0,.3.1,0,0,.1.2,0,.3l-3.3,22.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 82.2,
    y: 34,
    width: 22.7,
    height: 0.9,
    transform: "translate(42.8 120.3) rotate(-79.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 67.1,
    y: 23.3,
    width: 0.9,
    height: 22.4,
    transform: "translate(-2.4 5.1) rotate(-4.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 71.1,
    y: 34,
    width: 22.4,
    height: 0.9,
    transform: "translate(42.4 114.3) rotate(-86.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 70.7,
    y: 23.3,
    width: 0.9,
    height: 22.3,
    transform: "translate(-1.3 2.9) rotate(-2.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 67.5,
    y: 34,
    width: 22.3,
    height: 0.9,
    transform: "translate(41.4 111.7) rotate(-87.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.9,46.1h0c-.2,0-.4-.2-.4-.4h0s0-22.3,0-22.3c0-.2.2-.4.4-.4h0c.2,0,.4.2.4.4h0s0,22.3,0,22.3c0,.2-.2.4-.4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99.2,34.6l-.9-5.1h-47.1v-.9h47.5c.2,0,.4.1.4.4l1,5.5-.8.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99.2,40.2l-1.9-5.3h-45.2v-.9h45.5c.2,0,.3.1.4.3l2,5.5-.8.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 53.3,
    y: 39.6,
    width: 43.4,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "50.4 51.3 49.8 50.7 53.8 45.5 49.7 23.4 50.5 23.2 54.8 45.7 50.4 51.3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 50.9,
    y: 23.3,
    width: 0.9,
    height: 24.8,
    transform: "translate(-3.2 5.1) rotate(-5.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99.6,51.3l-4.2-5.4c0,0-.1-.2,0-.3l4.2-22.3c0-.2.3-.4.5-.3.2,0,.4.2.4.5l-2.4,24.5,2.3,2.9-.7.5ZM96.1,45.5l1,1.3,1.4-14.1-2.4,12.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 48.6,
    y: 42.4,
    width: 6.3,
    height: 0.9,
    transform: "translate(-10.3 68.6) rotate(-62.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 48.1,
    y: 36.8,
    width: 6,
    height: 0.9,
    transform: "translate(-1.5 72.2) rotate(-69.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 47.8,
    y: 31.2,
    width: 5.6,
    height: 0.9,
    transform: "translate(10.2 75.5) rotate(-79.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 97.7,
    y: 40,
    width: 0.9,
    height: 6.1,
    transform: "translate(-8.5 53.6) rotate(-29.3)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.8,76.3c0,.4-3.1.8-6.8.8s-6.8-.3-6.8-.8,3.1-.8,6.8-.8,6.8.3,6.8.8Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75,67.3c-3.7,0-6.8-3-6.8-6.8s3-6.8,6.8-6.8,6.8,3,6.8,6.8-3,6.8-6.8,6.8ZM75,53.9c-3.6,0-6.6,2.9-6.6,6.6s2.9,6.6,6.6,6.6,6.6-2.9,6.6-6.6-2.9-6.6-6.6-6.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "70.5 59.1 69.2 58.2 69.9 56.1 72.4 54.6 73.7 55.4 73.6 55.5 72.4 54.9 70.1 56.2 69.5 58.2 70.6 58.9 70.5 59.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "69.3 62.7 68.3 60.5 69.3 58.2 69.4 58.2 68.5 60.5 69.4 62.4 70.6 61.8 70.7 61.9 69.3 62.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "72.4 66.3 70 65.1 69.3 62.6 69.4 62.5 70.2 64.9 72.4 66.1 73.6 65.3 73.7 65.5 72.4 66.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "79.5 59.1 79.4 58.9 80.5 58.2 79.9 56.2 77.6 54.9 76.4 55.5 76.3 55.4 77.6 54.6 80.1 56.1 80.8 58.2 79.5 59.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "80.7 62.7 79.3 61.9 79.4 61.8 80.6 62.4 81.5 60.5 80.6 58.2 80.7 58.2 81.7 60.5 80.7 62.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "77.6 66.3 76.3 65.5 76.4 65.3 77.6 66.1 79.8 64.9 80.6 62.5 80.7 62.6 80 65.1 77.6 66.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "72.7 57.5 75 58.9 75 61.9 73 63.1 70.6 61.9 70.5 59 72.7 57.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73,63.3l-2.4-1.3v-3c-.1,0,2.1-1.5,2.1-1.5l2.4,1.4v3.1l-2.1,1.3ZM70.7,61.8l2.2,1.2,2-1.2v-2.9l-2.2-1.3-2.1,1.4v2.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "75 55.2 73.7 55.4 72.7 57.5 75 58.9 77.3 57.5 76.3 55.4 75 55.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75,59l-2.4-1.4,1-2.2,1.4-.3,1.4.3,1,2.2-2.4,1.4ZM72.8,57.5l2.2,1.3,2.1-1.3-.9-1.9-1.3-.3-1.2.3-.9,1.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "77.3 57.5 75 58.9 75 61.9 77.1 63.1 79.4 61.9 79.5 59 77.3 57.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77,63.3l-2.1-1.3v-3.1l2.4-1.4,2.2,1.5v3c-.1,0-2.5,1.3-2.5,1.3ZM75.1,61.8l1.9,1.2,2.2-1.2v-2.8c0,0-1.9-1.4-1.9-1.4l-2.2,1.3v2.9Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 76.5,
    y: 66.5,
    width: 1.2,
    height: 0.2,
    transform: "translate(-24.7 63.1) rotate(-38.9)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "73.7 65.4 75 65.8 76.3 65.4 77.1 63.1 75 61.9 73 63.1 73.7 65.4 75 65.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75,65.9l-1.4-.4-.7-2.4,2.1-1.4,2.3,1.4-.9,2.4-1.4.4ZM73.8,65.3l1.3.4,1.2-.4.8-2.1-2-1.2-1.9,1.2.7,2.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M80.3,56.4l-2.8-1.5-1.2-1h.4c1.7.4,3.2,1.9,3.3,2h0s.3.5.3.5ZM77.6,54.7l1.9,1c-.5-.4-1.4-1.2-2.5-1.5l.6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70,56.3v-.3h0c0,0,1.6-1.7,3.3-2h.4c0,0-1.2.9-1.2.9l-2.5,1.4ZM72.9,54.2c-1,.3-2,1.1-2.5,1.5l1.9-1.1.6-.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M76.3,55.6l-1.4-.4-1.3.4-1.3-.8.9-.7s1.9-.5,3.4,0l.9.7-1.3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.3,55.7l-1.4-.4-1.3.4-1.4-.9,1-.8h0c0,0,2-.5,3.5,0h.2c0,0,.8.8.8.8l-1.4.9ZM74.9,55.1l1.3.4,1.1-.7-.8-.6c-1.4-.4-3.1,0-3.3,0l-.8.6,1.1.7,1.2-.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.7,67.1h-.4c-1.7-.4-3.2-1.9-3.3-2l-.4-.4,2.8,1.4,1.2,1ZM70.7,65.5c.5.4,1.3,1,2.2,1.3l-.6-.5-1.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M76.3,67.1l1.2-1,2.8-1.4-.4.4c0,0-1.6,1.6-3.3,1.9h-.4ZM77.6,66.3l-.6.5c.9-.3,1.7-.9,2.2-1.3l-1.7.8Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.7,65.4l1.4.4,1.3-.4,1.3.8-1,.7s-1.4.5-3.4,0l-.8-.7,1.3-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.8,67.2c-.8-.1-.9,0-1.5-.2h-.1s-.9-.8-.9-.8l1.4-.9,1.4.4,1.3-.4,1.4.9-1,.8h0c0,0-.9.1-1.8.1ZM73.3,66.9c1.4.4,3,.2,3.3,0l.8-.6-1.1-.7-1.2.4-1.3-.4-1.1.7.8.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75,67.3c-3.7,0-6.8-3-6.8-6.8s3-6.8,6.8-6.8,6.8,3,6.8,6.8-3,6.8-6.8,6.8ZM75,53.9c-3.6,0-6.6,2.9-6.6,6.6s2.9,6.6,6.6,6.6,6.6-2.9,6.6-6.6-2.9-6.6-6.6-6.6Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.4,70.8c-3.7,0-6.8-3-6.8-6.8s3-6.8,6.8-6.8,6.8,3,6.8,6.8-3,6.8-6.8,6.8ZM57.4,57.5c-3.6,0-6.6,2.9-6.6,6.6s2.9,6.6,6.6,6.6,6.6-2.9,6.6-6.6-2.9-6.6-6.6-6.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "52.8 62.6 51.6 61.8 52.3 59.6 54.7 58.2 56.1 58.9 56 59 54.7 58.4 52.4 59.7 51.8 61.7 52.9 62.4 52.8 62.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "51.6 66.2 50.6 64 51.6 61.7 51.8 61.8 50.8 64 51.7 65.9 52.9 65.3 53 65.5 51.6 66.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "54.7 69.8 52.4 68.6 51.6 66.1 51.8 66 52.5 68.5 54.7 69.6 56 68.8 56.1 69 54.7 69.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "61.9 62.6 61.7 62.4 62.9 61.7 62.2 59.7 59.9 58.4 58.7 59 58.6 58.9 59.9 58.2 62.4 59.6 63.1 61.8 61.9 62.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "63 66.2 61.6 65.5 61.7 65.3 62.9 65.9 63.9 64 62.9 61.8 63.1 61.7 64.1 64 63 66.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "59.9 69.8 58.6 69 58.7 68.8 59.9 69.6 62.1 68.5 62.9 66 63.1 66.1 62.3 68.6 59.9 69.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "55 61 57.4 62.4 57.4 65.4 55.3 66.7 53 65.4 52.9 62.5 55 61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.3,66.8l-2.4-1.3v-3c-.1,0,2.1-1.5,2.1-1.5l2.4,1.4v3.1l-2.1,1.3ZM53.1,65.3l2.2,1.2,2-1.2v-2.9l-2.2-1.3-2.1,1.4v2.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "57.3 58.7 56 59 55 61 57.4 62.4 59.6 61 58.6 59 57.3 58.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.4,62.5l-2.4-1.4,1-2.2,1.4-.3,1.4.3,1,2.2-2.4,1.4ZM55.2,61l2.2,1.3,2.1-1.3-.9-1.9-1.3-.3-1.2.3-.9,1.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "59.7 61 57.4 62.4 57.4 65.4 59.4 66.7 61.7 65.4 61.8 62.5 59.7 61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.4,66.8l-2.1-1.3v-3.1l2.4-1.4,2.2,1.5v3c-.1,0-2.5,1.3-2.5,1.3ZM57.5,65.3l1.9,1.2,2.2-1.2v-2.8c0,0-1.9-1.4-1.9-1.4l-2.2,1.3v2.9Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 58.9,
    y: 70,
    width: 1.2,
    height: 0.2,
    transform: "translate(-30.8 52.8) rotate(-38.9)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "56 68.9 57.4 69.3 58.6 68.9 59.5 66.7 57.3 65.4 55.3 66.7 56 68.9 57.4 69.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.4,69.4l-1.4-.4-.7-2.4,2.1-1.4,2.3,1.4-.9,2.4-1.4.4ZM56.1,68.8l1.3.4,1.2-.4.8-2.1-2-1.2-1.9,1.2.7,2.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.6,59.9l-2.8-1.5-1.2-1h.4c1.7.4,3.2,1.9,3.3,2h0s.3.5.3.5ZM59.9,58.2l1.9,1c-.5-.4-1.4-1.2-2.5-1.5l.6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.3,59.8v-.3h0c0,0,1.6-1.7,3.3-2h.4c0,0-1.2.9-1.2.9l-2.5,1.4ZM55.3,57.7c-1,.3-2,1.1-2.5,1.5l1.9-1.1.6-.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.6,59.1l-1.4-.4-1.3.4-1.3-.8.9-.7s1.9-.5,3.4,0l.9.7-1.3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.6,59.2l-1.4-.4-1.3.4-1.4-.9,1-.8h0c0,0,2-.5,3.5,0h.2c0,0,.8.8.8.8l-1.4.9ZM57.2,58.6l1.3.4,1.1-.7-.8-.6c-1.4-.4-3.1,0-3.3,0l-.8.6,1.1.7,1.2-.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56,70.6h-.4c-1.7-.4-3.2-1.9-3.3-2l-.4-.4,2.8,1.4,1.2,1ZM53,69c.5.4,1.3,1,2.2,1.3l-.6-.5-1.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.6,70.6l1.2-1,2.8-1.4-.4.4c0,0-1.6,1.6-3.3,1.9h-.4ZM59.9,69.8l-.6.5c.9-.3,1.7-.9,2.2-1.3l-1.7.8Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56,68.9l1.4.4,1.3-.4,1.3.8-1,.7s-1.4.5-3.4,0l-.8-.7,1.3-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.2,70.7c-.8-.1-.9,0-1.5-.2h-.1s-.9-.8-.9-.8l1.4-.9,1.4.4,1.3-.4,1.4.9-1,.8h0c0,0-.9.1-1.8.1ZM55.7,70.4c1.4.4,3,.2,3.3,0l.8-.6-1.1-.7-1.2.4-1.3-.4-1.1.7.8.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.3,70.8c-3.7,0-6.8-3-6.8-6.8s3-6.8,6.8-6.8,6.8,3,6.8,6.8-3,6.8-6.8,6.8ZM57.3,57.5c-3.6,0-6.6,2.9-6.6,6.6s2.9,6.6,6.6,6.6,6.6-2.9,6.6-6.6-2.9-6.6-6.6-6.6Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M92.6,70.8c-3.7,0-6.8-3-6.8-6.8s3-6.8,6.8-6.8,6.8,3,6.8,6.8-3,6.8-6.8,6.8ZM92.6,57.5c-3.6,0-6.6,2.9-6.6,6.6s2.9,6.6,6.6,6.6,6.6-2.9,6.6-6.6-2.9-6.6-6.6-6.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "88.1 62.6 86.8 61.8 87.5 59.6 90 58.2 91.3 58.9 91.2 59 90 58.4 87.7 59.7 87.1 61.7 88.2 62.4 88.1 62.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "86.9 66.2 85.9 64 86.9 61.7 87 61.8 86.1 64 87 65.9 88.2 65.3 88.3 65.5 86.9 66.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "90 69.8 87.6 68.6 86.9 66.1 87 66 87.8 68.5 90 69.6 91.2 68.8 91.3 69 90 69.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "97.1 62.6 97 62.4 98.1 61.7 97.5 59.7 95.2 58.4 94 59 93.9 58.9 95.2 58.2 97.7 59.6 98.4 61.8 97.1 62.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "98.3 66.2 96.9 65.5 97 65.3 98.2 65.9 99.1 64 98.2 61.8 98.3 61.7 99.3 64 98.3 66.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "95.2 69.8 93.9 69 94 68.8 95.2 69.6 97.4 68.5 98.2 66 98.3 66.1 97.6 68.6 95.2 69.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "90.3 61 92.6 62.4 92.6 65.4 90.6 66.7 88.2 65.4 88.1 62.5 90.3 61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.6,66.8l-2.4-1.3v-3c-.1,0,2.1-1.5,2.1-1.5l2.4,1.4v3.1l-2.1,1.3ZM88.3,65.3l2.2,1.2,2-1.2v-2.9l-2.2-1.3-2.1,1.4v2.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "92.6 58.7 91.3 59 90.3 61 92.6 62.4 94.9 61 93.9 59 92.6 58.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.6,62.5l-2.4-1.4,1-2.2,1.4-.3,1.4.3,1,2.2-2.4,1.4ZM90.4,61l2.2,1.3,2.1-1.3-.9-1.9-1.3-.3-1.2.3-.9,1.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "94.9 61 92.6 62.4 92.6 65.4 94.6 66.7 97 65.4 97.1 62.5 94.9 61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.6,66.8l-2.1-1.3v-3.1l2.4-1.4,2.2,1.5v3c-.1,0-2.5,1.3-2.5,1.3ZM92.7,65.3l1.9,1.2,2.2-1.2v-2.8c0,0-1.9-1.4-1.9-1.4l-2.2,1.3v2.9Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 94.1,
    y: 70,
    width: 1.2,
    height: 0.2,
    transform: "translate(-23 74.9) rotate(-38.9)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "91.3 68.9 92.6 69.3 93.9 68.9 94.7 66.7 92.6 65.4 90.6 66.7 91.3 68.9 92.6 69.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.6,69.4l-1.4-.4-.7-2.4,2.1-1.4,2.3,1.4-.9,2.4-1.4.4ZM91.4,68.8l1.3.4,1.2-.4.8-2.1-2-1.2-1.9,1.2.7,2.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97.9,59.9l-2.8-1.5-1.2-1h.4c1.7.4,3.2,1.9,3.3,2h0s.3.5.3.5ZM95.2,58.2l1.9,1c-.5-.4-1.4-1.2-2.5-1.5l.6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M87.6,59.8v-.3h0c0,0,1.6-1.7,3.3-2h.4c0,0-1.2.9-1.2.9l-2.5,1.4ZM90.5,57.7c-1,.3-2,1.1-2.5,1.5l1.9-1.1.6-.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.9,59.1l-1.4-.4-1.3.4-1.3-.8.9-.7s1.9-.5,3.4,0l.9.7-1.3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93.9,59.2l-1.4-.4-1.3.4-1.4-.9,1-.8h0c0,0,2-.5,3.5,0h.2c0,0,.8.8.8.8l-1.4.9ZM92.5,58.6l1.3.4,1.1-.7-.8-.6c-1.4-.4-3.1,0-3.3,0l-.8.6,1.1.7,1.2-.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.3,70.6h-.4c-1.7-.4-3.2-1.9-3.3-2l-.4-.4,2.8,1.4,1.2,1ZM88.3,69c.5.4,1.3,1,2.2,1.3l-.6-.5-1.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.9,70.6l1.2-1,2.8-1.4-.4.4c0,0-1.6,1.6-3.3,1.9h-.4ZM95.2,69.8l-.6.5c.9-.3,1.7-.9,2.2-1.3l-1.7.8Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.3,68.9l1.4.4,1.3-.4,1.3.8-1,.7s-1.4.5-3.4,0l-.8-.7,1.3-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.4,70.7c-.8-.1-.9,0-1.5-.2h-.1s-.9-.8-.9-.8l1.4-.9,1.4.4,1.3-.4,1.4.9-1,.8h0c0,0-.9.1-1.8.1ZM90.9,70.4c1.4.4,3,.2,3.3,0l.8-.6-1.1-.7-1.2.4-1.3-.4-1.1.7.8.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M92.6,70.8c-3.7,0-6.8-3-6.8-6.8s3-6.8,6.8-6.8,6.8,3,6.8,6.8-3,6.8-6.8,6.8ZM92.6,57.5c-3.6,0-6.6,2.9-6.6,6.6s2.9,6.6,6.6,6.6,6.6-2.9,6.6-6.6-2.9-6.6-6.6-6.6Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTirAuButHand);
export default __webpack_public_path__ + "static/media/tir_au_but_hand.bdd5db456b0302b22b84fb61052a9435.svg";
export { ForwardRef as ReactComponent };